import loadingGif from "../../../assets/emlogo-loading.gif";

// The source GIF is 128px, so 64px is the largest size that stays sharp on 2x screens.
const SIZES = { sm: 24, md: 48, lg: 64 };

// Brand loading animation; drop-in replacement for the circular spinners.
// `size` is "sm" | "md" | "lg" or a pixel number. Extra react-bootstrap
// Spinner props (animation, variant, as, ...) are accepted and ignored.
function EmLoader({ size = "md", className = "", style, label = "Loading" }) {
  const px = typeof size === "number" ? size : SIZES[size] || SIZES.md;
  return (
    <img
      src={loadingGif}
      alt={label}
      role="status"
      width={px}
      height={px}
      className={className}
      style={{
        display: "inline-block",
        verticalAlign: "middle",
        objectFit: "contain",
        ...style,
      }}
    />
  );
}

export default EmLoader;
